import { Cable, ShieldCheck, Layers, Wind } from "lucide-react";
import { Reveal } from "./motion";

const services = [
  { icon: Cable, code: "SS304", title: "SS304 Steel Cables", desc: "High-tensile 304-grade stainless steel wires — ideal for indoor balconies and covered windows. Excellent strength at a smart price." },
  { icon: ShieldCheck, code: "SS316", title: "SS316 Marine Grade", desc: "Premium 316-grade steel engineered for high-rise & coastal humidity. Superior corrosion resistance for the harshest weather." },
  { icon: Layers, code: "NYLON", title: "Nylon-Coated Cable", desc: "Steel core wrapped in a UV-stable nylon coat — softer finish, extra rust protection, and a clean architectural look." },
  { icon: Wind, code: "CUSTOM", title: "Custom Frameworks", desc: "Fully customised spans for irregular balconies, French windows, and utility areas with colour-matched aluminium tracks." },
];

export default function Services({ onQuote }) {
  return (
    <section id="services" className="py-24 md:py-36 bg-white border-t border-steel-200">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="grid md:grid-cols-12 gap-6 items-end mb-16">
          <div className="md:col-span-8">
            <p className="font-label text-xs tracking-[0.3em] uppercase text-steel-500 mb-4">What we install</p>
            <h2 className="font-display font-black tracking-tighter text-steel-900 text-4xl md:text-6xl leading-none">
              Engineered steel,<br /><span className="text-steel-400">barely there.</span>
            </h2>
          </div>
          <div className="md:col-span-4 text-steel-600 md:text-right">
            Choose the grade that fits your building & budget. Every install is measured, tensioned and finished by our own trained crew.
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-steel-200">
          {services.map((s, i) => (
            <Reveal key={s.code} delay={i * 0.08}>
              <div data-testid={`service-${s.code}`} className="group h-full border-r border-b border-steel-200 p-8 hover:bg-steel-800 transition-colors duration-300">
                <div className="flex items-center justify-between mb-10">
                  <s.icon className="text-steel-800 group-hover:text-white transition-colors" size={30} strokeWidth={1.4} />
                  <span className="font-label text-xs tracking-widest text-steel-400 group-hover:text-steel-300">{s.code}</span>
                </div>
                <h3 className="font-display font-bold text-xl text-steel-900 group-hover:text-white transition-colors mb-3">{s.title}</h3>
                <p className="text-sm text-steel-600 group-hover:text-steel-200 leading-relaxed transition-colors">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-10">
          <button onClick={onQuote} data-testid="services-quote-btn" className="bg-steel-800 text-white px-8 py-4 font-semibold hover:bg-steel-900 transition-colors">
            Not sure which grade? Get expert advice →
          </button>
        </Reveal>
      </div>
    </section>
  );
}
